module.exports = __webpack_public_path__ + "static/media/2.ce4d12d4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/avatars/2.png
 ** module id = 211
 ** module chunks = 0
 **/